import { useState } from "react";
import { Input } from "@/components/ui/input";
import { QuestionTooltip } from "./QuestionTooltip";
import { NumberInputQuestion } from "./questionTypes";

interface NumberQuestionProps {
  question: NumberInputQuestion;
  value: string;
  onChange: (questionId: string, value: string) => void;
}

export function NumberQuestion({ question, value, onChange }: NumberQuestionProps) {
  const [touched, setTouched] = useState(false);
  const numValue = value !== "" ? Number(value) : undefined;
  const min = question.minNum;
  const max = question.maxNum;
  const outOfRange = touched && numValue !== undefined && (
    (min !== undefined && numValue < min) || (max !== undefined && numValue > max)
  );

  return (
    <div className="space-y-8 w-full max-w-4xl mr-auto py-4 min-h-[400px] text-left">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-3">{question.title}</h2>
        {question.description && <p className="text-muted-foreground">{question.description}</p>}
        {question.tooltip && <QuestionTooltip tooltip={question.tooltip} />}
      </div>

      <div className="space-y-2">
        <Input
          id={question.id}
          type="number"
          min={min}
          max={max}
          placeholder={question.placeholder || "Enter a number"}
          value={value || ""}
          onBlur={() => setTouched(true)}
          onChange={(e) => onChange(question.id, e.target.value)}
          className={`w-full max-w-xs text-lg py-4 px-6 min-h-[60px] ${outOfRange ? "border-destructive" : ""}`}
        />
        {outOfRange && (
          <p className="text-sm text-destructive">
            {min !== undefined && max !== undefined
              ? `Please enter a value between ${min} and ${max}`
              : min !== undefined
                ? `Minimum value is ${min}`
                : `Maximum value is ${max}`}
          </p>
        )}
      </div>
    </div>
  );
}
